<template>
  <div id="brandings">

    <Datatable
        v-if="inventory"
        entity="branding"
        class="datatable"
        ref="datatable"
        :parameters="{inventory: inventory.id, company: company}"
        :onRowClick="onRowClick"
        :globalActions="[
            {text: 'branding.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
            {text: 'branding.categories', method: manageCategories, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
            ]"
        :rowActions="[
        {text: 'datatable.edit', method: onRowEdit },
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>

    <Modal
        name="delete-confirmation"
        :title="$t('categories.confirmation')"
        dismissable
        :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteBrandingAction, primary: true}]">
      <p>{{$t('branding.delete_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import {mapActions} from "vuex";

  export default {
    name: "Brandings",

    components: { Datatable },

    data() {
      return {
        actionRow: {},
        entityName: 'brandings'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory;
      },
      company() {
        return this.$route.query.company || undefined;
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "branding.title";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      onRowClick(row) {
        this.onRowEdit(row);
      },
      onCreate() {
        this.$router.push(this.$router.buildContext('/branding/new'));
      },
      manageCategories() {
        this.$router.push(this.$router.buildContext('/branding/categories'));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext('/branding/edit', {id: row.id}));
      },
      onRowDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },
      async deleteBrandingAction() {
        this.$store.commit("showSpinner", true);
        let response = await this.deleteInventoryEntity({entity: this.entityName, inventory: this.inventory.id, id: this.actionRow.id});
        if (response) {
          this.$modal.show("delete-confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$modal.show("delete-confirmation", false);
          toast(this.$t("error.no_server"),"error");
          this.$store.commit("showSpinner", false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
